import React from 'react'
//import env from 'react-dotenv'
import { Form, Input, Row, Col, Switch, Icon ,notification} from 'antd'
import Search from '../../components/Search'
import API from '../../services/API'
import { useDebounce } from 'usehooks-ts'

const { TextArea } = Input

const PanelGeneralData = ({ data, change }) => {
    const [currenSearchBrand, setCurrenSearchBrand] = React.useState('')
    const [currenSearchProductType, setCurrenSearchProductType] = React.useState('')
    const [currenSearchMeasureUnit, setCurrenSearchMeasureUnit] = React.useState('')
    const [currenSearchCurrency, setCurrenSearchCurrency] = React.useState('')

    const [fieldAviable, setFieldAviable] = React.useState({
        sku: null,
        barcode: null,
    });
    const debouncedFieldAviable = useDebounce(fieldAviable, 800);

    React.useEffect(() => {
        if (data.brand) {
            setCurrenSearchBrand(data.brand)
        }
        if (data.product_type) {
            setCurrenSearchProductType(data.product_type)
        }
        if (data.measure_unit) {
            setCurrenSearchMeasureUnit(data.measure_unit)
        }

        if (data.currency) {
            setCurrenSearchCurrency(data.currency)
        }
    }, [data.brand, data.product_type, data.measure_unit, data.currency]);

    React.useEffect(() => { // validacion de sku y barcode.
        let isExist = false;
        if(debouncedFieldAviable.sku_exact === false){
            notification.error({
                message: 'Ya existe un producto con el SKU '+data.sku+' en la base de datos.',
            });
            isExist = true;
        }
        if(debouncedFieldAviable.barcode_exact === false){
            notification.error({
                message: 'Ya existe un producto con el codigo de barras '+data.barcode+' en la base de datos.',
            });
            isExist = true;
        }
        change('disabled', isExist);
    }, [debouncedFieldAviable]);


    const validateFieldAvailable = (field, value) => {
        API.get(`/api/products?filter[${field}]=${value}`)
            .then(response => {
                const has = response.data.data.length === 0
                setFieldAviable({ ...fieldAviable, [field]: has })
            })
            .catch(error => {
                console.error(error)
            })
    }

    const getIcon = field => {
        if (fieldAviable[field] == null || data[field.replace('_exact', '')].length === 0) {
            return <Icon type="search"  />
        }
        if (fieldAviable[field]) {
            return <Icon type="check" style={{ color: 'green' }} />
        }
        return <Icon type="close" style={{ color: 'red' }} />
    }

    React.useEffect(() => {
        change('slug', data.name.replace(/[^\w-]+/g, "-").toLowerCase())
    }, [data.name])

    return (
        <>
            <Row gutter={24}>
                <Col lg={16} md={24} sm={24}>
                    <Form.Item label="Nombre" className="required" hasFeedback>
                        <Input
                            placeholder="Nombre"
                            value={data.name}
                            onChange={e => {
                                change('name', e.target.value)
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={8} md={24} sm={24}>
                    <Form.Item label="Activo">
                        <Switch
                            defaultChecked={!!data.active}
                            onChange={value => {
                                change('active', value)
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={8} md={12} sm={24}>
                    <Form.Item label="SKU" hasFeedback>
                        <Input
                            placeholder="SKU"
                            value={data.sku}
                            addonAfter={getIcon('sku_exact')}
                            onChange={e => {
                                change('sku', e.target.value)
                                if (e.target.value.length >= 3 && !data.id) {
                                    validateFieldAvailable('sku_exact', e.target.value)
                                }
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} sm={24}>
                    <Form.Item label="Código de barras" hasFeedback>
                        <Input
                            placeholder="Código de barras"
                            value={data.barcode}
                            addonAfter={getIcon('barcode_exact')}
                            onChange={e => {
                                change('barcode', e.target.value)
                                if (e.target.value.length >= 5 && !data.id) {
                                    validateFieldAvailable('barcode_exact', e.target.value)
                                }
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col lg={4} md={12} sm={24}>
                    <Form.Item label="Código del SAT" hasFeedback>
                       <Input
                        placeholder="Escribe el código del SAT"
                        value={data.sat_code}
                        onChange={e => {
                            change('sat_code', e.target.value);
                         }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} sm={24}>
                    <Form.Item label="Descripción SAT" hasFeedback>
                        <Input
                            placeholder="Descripción SAT"
                            value={data.sat_code_item ? data.sat_code_item.description : ''}
                            disabled
                        />
                    </Form.Item>
                </Col>

                <Col lg={4} md={12} sm={24}>
                    <Form.Item label="Clave de unidad SAT" hasFeedback>
                       <Input
                        placeholder="Escribe la clave de unidad SAT"
                        value={data.sat_unit_code}
                        onChange={e => {
                            change('sat_unit_code', e.target.value);
                         }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={6} md={12} sm={24}>
                    <Form.Item label="Unidad SAT" hasFeedback>
                        <Input
                            placeholder="Unidad SAT"
                            value={data.sat_unit_code_item ? data.sat_unit_code_item.name : ''}
                            disabled
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col lg={24} md={24} sm={24}>
                    <Form.Item label="Descripción" hasFeedback>
                        <TextArea
                            style={{ resize: 'none' }}
                            rows={2}
                            placeholder="Descripción"
                            value={data.description}
                            onChange={e => {
                                change('description', e.target.value)
                            }}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col lg={8} md={12} sm={24}>
                    <Form.Item className="required" label="Marca">
                        <Search
                            id="brand_id"
                            value={currenSearchBrand}
                            placeholder="Busca una marca"
                            onSearch={value => `/api/brands?filter[name]=${value}&pagination=false`}
                            keyName="id"
						    label="name"
                            onChange={(key, value) => {
                                change('brand_id', key)
                                setCurrenSearchBrand(value)
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={8} md={12} sm={24}>
                    <Form.Item className="required" label="Tipo de producto">
                        <Search
                            id="product_type_id"
                            value={currenSearchProductType}
                            placeholder="Tipo de producto"
                            onSearch={value => `/api/product_types?filter[name]=${value}&pagination=false`}
                            keyName="id"
						    label="name"
                            onChange={(key, value) => {
                                change('product_type_id', key)
                                setCurrenSearchProductType(value)
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={8} md={12} sm={24}>
                    <Form.Item label="Slug" hasFeedback>
                        <Input
                            addonBefore={window.location.origin.replace('admin.', '') + '/product/'}
                            placeholder="Slug"
                            value={data.slug}
                            onChange={e => {
                                change('slug', e.target.value.replace(/[^a-zA-Z0-9]/g, '').toLowerCase())
                            }}
                        />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col lg={8} md={12} sm={24}>
                    <Form.Item className="required" label="Unidad de medida">
                        <Search
                            id="measure_unit_id"
                            value={currenSearchMeasureUnit}
                            placeholder="Unidad de medida"
                            onSearch={value => `/api/measure_units?filter[name]=${value}`}
                            keyName="id"
						    label="name"
                            onChange={(key, value) => {
                                change('measure_unit_id', key)
                                setCurrenSearchMeasureUnit(value)
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col lg={8} md={12} sm={24}>
                    <Form.Item className="required" label="Moneda">
                        <Search
                            id="currency_id"
                            value={currenSearchCurrency}
                            placeholder="Moneda"
                            onSearch={value => `/api/currencies?filter[name]=${value}`}
                            keyName="id"
						    label="name"
                            onChange={(key, value) => {
                                change('currency_id', key)
                                setCurrenSearchCurrency(value)
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col lg={8} md={12} sm={24}>
                    <Form.Item label="Cantidad minima en almacén" hasFeedback>
                        <Input
                            placeholder="Escribe la cantidad minima en almacén"
                            value={data.min_supply}
                            onChange={e => {
                                const newNumber = parseInt(e.target.value || '0', 10);
                                if (Number.isNaN(newNumber)) {
                                    return;
                                }
                                change('min_supply',newNumber)
                            }}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

export default PanelGeneralData
